import { useContext } from "react";

import { DigitalAssetContext as ContinenteDigitalAssetContext } from "@/contexts/continente-credentials/DigitalAssetContext";
import { DigitalAssetContext as SiteDigitalAssetContext } from "@/contexts/site-credentials/DigitalAssetContext";
import { FooterAssetKey, FooterDisplayMode } from "@/config/FooterAssetsCatalog";

const VALID_DISPLAY_MODES: FooterDisplayMode[] = ["grid", "carousel", "none"];

function isFooterDisplayMode(value: string | undefined): value is FooterDisplayMode {
  return !!value && (VALID_DISPLAY_MODES as string[]).includes(value);
}

export function useFooterDisplayMode(): {
  displayMode: FooterDisplayMode;
  excludeAssetKey?: FooterAssetKey;
} {
  const { digitalAsset: richAsset } = useContext(ContinenteDigitalAssetContext);
  const { digitalAsset: thinAsset } = useContext(SiteDigitalAssetContext);

  const source = richAsset.clientId ? richAsset : thinAsset.clientId ? thinAsset : undefined;

  const displayMode: FooterDisplayMode = isFooterDisplayMode(source?.assetsDisplayMode)
    ? (source?.assetsDisplayMode as FooterDisplayMode)
    : "grid";

  return {
    displayMode,
    excludeAssetKey: source?.assetAlias as FooterAssetKey | undefined,
  };
}

export default useFooterDisplayMode;
